export default {
  'pages.appStore.refresh': '重新整理',
  'pages.appStore.install': '部署',
  'pages.appStore.cancel': '取消',
  'pages.appStore.confirmInstall': '部署到叢集',
  'pages.appStore.installCount': '已部署 {count} 次',
  'pages.appStore.spec':
    '{cpu} 核 CPU · {memory} MiB 記憶體 · {storage} GiB 儲存',
  'pages.appStore.installTitle': '部署 {name}',
  'pages.appStore.installSuccess': '部署「{name}」已提交',
  'pages.appStore.installSuccessDescription':
    '服務正在企業叢集中建立，通常需要一到兩分鐘完成啟動，可在我的部署中查看執行狀態與存取位址。',
  'pages.appStore.continueBrowsing': '繼續瀏覽',
  'pages.appStore.viewDeployments': '查看我的部署',
  'pages.appStore.title': '部署範本',
  'pages.appStore.description':
    '一鍵將資料庫、快取、運維工具等雲原生應用部署到企業專屬叢集，開箱即用。',
  'pages.appStore.searchPlaceholder': '搜尋名稱、標籤或描述',
  'pages.appStore.empty': '找不到符合的應用',
  'pages.appStore.allCategories': '全部',
  'pages.appStore.category.database': '資料庫',
  'pages.appStore.category.cache': '快取',
  'pages.appStore.category.storage': '儲存',
  'pages.appStore.category.messaging': '訊息佇列',
  'pages.appStore.category.devtools': '開發工具',
  'pages.appStore.category.monitoring': '監控運維',
  'pages.appStore.category.other': '其他',
  'pages.appStore.field.name': '部署名稱',
  'pages.appStore.field.nameHelp': '同時作為叢集內的服務名稱，部署後不可修改。',
  'pages.appStore.field.nameRequired': '請輸入部署名稱',
  'pages.appStore.field.nameInvalid':
    '只能包含小寫字母、數字和連字號，以字母開頭，長度不超過 40',
  'pages.appStore.field.description': '描述',
  'pages.appStore.field.inputs': '初始化參數',
  'pages.appStore.field.inputRequired': '請填寫{label}',
  'pages.appStore.deployments.title': '我的部署',
  'pages.appStore.deployments.description':
    '查看已部署到企業叢集的應用與服務，支援公網與內網存取。',
  'pages.appStore.deployments.name': '部署名稱',
  'pages.appStore.deployments.type': '類型/來源',
  'pages.appStore.deployments.status': '狀態',
  'pages.appStore.deployments.endpoint': '存取位址',
  'pages.appStore.deployments.spec': '規格',
  'pages.appStore.deployments.createdBy': '部署人',
  'pages.appStore.deployments.createdAt': '部署時間',
  'pages.appStore.deployments.actions': '操作',
  'pages.appStore.deployments.delete': '刪除',
  'pages.appStore.deployments.deleteTitle': '刪除部署「{name}」？',
  'pages.appStore.deployments.deleteDescription':
    '會同時刪除資料卷且不可恢復。',
  'pages.appStore.deployments.empty': '尚未有任何部署',
  'pages.appStore.deployments.installFromStore': '從部署範本安裝',
  'pages.appStore.deployments.customDeploy': '自訂部署',
  'pages.appStore.deployments.customTag': '自訂',
  'pages.appStore.deployments.publicLink': '公網存取',
  'pages.appStore.deployments.internalPrefix': '內網',
  'pages.appStore.status.running': '執行中',
  'pages.appStore.status.pending': '啟動中',
  'pages.appStore.status.failed': '異常',
  'pages.appStore.status.stopped': '未執行',
  'pages.appStore.status.unknown': '叢集未接入',
  'pages.appStore.status.paused': '已暫停',
  'pages.appStore.deployments.edit': '變更',
  'pages.appStore.deployments.more': '更多',
  'pages.appStore.deployments.restart': '重啟',
  'pages.appStore.deployments.pause': '暫停',
  'pages.appStore.deployments.start': '啟動',
  'pages.appStore.deployments.autoscalingTag': '彈性 {min}~{max}',
  'pages.appStore.deployments.restartTitle': '重啟部署「{name}」？',
  'pages.appStore.deployments.restartDescription':
    '所有實例會滾動重建，期間服務可能短暫無法使用。',
  'pages.appStore.deployments.restartDone': '部署「{name}」正在重啟',
  'pages.appStore.deployments.pauseTitle': '暫停部署「{name}」？',
  'pages.appStore.deployments.pauseDescription':
    '所有實例會被停止，存取位址暫時無法使用；設定與資料卷會保留，可隨時啟動。',
  'pages.appStore.deployments.pauseDone': '部署「{name}」已暫停',
  'pages.appStore.deployments.startTitle': '啟動部署「{name}」？',
  'pages.appStore.deployments.startDescription':
    '依暫停前的實例數與彈性伸縮設定恢復執行。',
  'pages.appStore.deployments.startDone': '部署「{name}」正在啟動',
  'pages.appStore.deployments.deleteDone': '部署「{name}」已刪除',
  'pages.appStore.form.createTitle': '應用部署',
  'pages.appStore.form.editTitle': '變更部署 · {name}',
  'pages.appStore.form.exportYaml': '匯出 YAML',
  'pages.appStore.form.submitUpdate': '確認變更',
  'pages.appStore.form.viewForm': '設定表單',
  'pages.appStore.form.viewYaml': 'YAML 檔案',
  'pages.appStore.form.copyYaml': '複製 YAML',
  'pages.appStore.form.copied': '已複製',
  'pages.appStore.form.section.basic': '基本資訊',
  'pages.appStore.form.section.resource': '資源設定',
  'pages.appStore.form.section.network': '網路設定',
  'pages.appStore.form.section.advanced': '進階設定',
  'pages.appStore.form.summaryTitle': '資源彙總',
  'pages.appStore.form.summaryInstances': '實例數',
  'pages.appStore.form.summaryStorage': '儲存卷',
  'pages.appStore.form.enabled': '已開啟',
  'pages.appStore.form.disabled': '未開啟',
  'pages.appStore.form.cores': '{value} 核',
  'pages.appStore.form.scalingMode': '實例',
  'pages.appStore.form.scalingFixed': '固定實例',
  'pages.appStore.form.scalingAuto': '彈性伸縮',
  'pages.appStore.form.instances': '實例數',
  'pages.appStore.form.autoTarget': '目標值',
  'pages.appStore.form.autoTargetCpuHint':
    '當實例平均 CPU 使用量超過上限的此比例時自動擴容，低於時縮容。',
  'pages.appStore.form.autoTargetMemoryHint':
    '當實例平均記憶體使用量超過上限的此比例時自動擴容，低於時縮容。',
  'pages.appStore.form.instanceRange': '實例範圍',
  'pages.appStore.form.instanceRangeInvalid': '最大實例數不能小於最小實例數',
  'pages.appStore.form.sharedVolumeNoAuto':
    '舊版本建立的帶儲存部署不支援彈性伸縮',
  'pages.appStore.form.sharedVolumeSingle':
    '此部署建立於舊版本，所有實例共用同一個儲存卷，只能執行 1 個實例。',
  'pages.appStore.form.networkHint':
    '部署後會自動產生叢集內存取位址；HTTP 連接埠可開啟公網存取並自動簽發 HTTPS 憑證。',
  'pages.appStore.form.containerPort': '容器連接埠',
  'pages.appStore.form.namePlaceholderHost': '<部署名稱>',
  'pages.appStore.form.commandHint': '不填寫時使用映像預設的啟動命令。',
  'pages.appStore.form.commandPlaceholder': '例如：/bin/sh -c',
  'pages.appStore.form.argsPlaceholder': '例如：sleep 10 && /entrypoint.sh',
  'pages.appStore.form.add': '新增',
  'pages.appStore.form.envBulkEdit': '批次編輯',
  'pages.appStore.form.envBulkTitle': '編輯環境變數',
  'pages.appStore.form.envBulkPlaceholder':
    '每行一個環境變數，以等號或冒號分隔，例如：\nmongoUrl=127.0.0.1:8000\nredisUrl:127.0.0.1:8001\n- env1=test',
  'pages.appStore.form.envBulkInvalid':
    '第 {lines} 行的變數名稱不合法：只能包含字母、數字與底線，且不能以數字開頭',
  'pages.appStore.form.envBulkCount':
    '共 {count} 個環境變數，儲存後會取代目前清單',
  'pages.appStore.form.localStorage': '本機儲存',
  'pages.appStore.form.storageHint':
    '每個實例各自掛載一份獨立的儲存卷，實例之間資料不互通。',
  'pages.appStore.form.storageImmutable': '儲存卷建立後不可修改。',
  'pages.appStore.form.perInstanceVolume':
    '多實例時每個實例各有一份獨立的儲存卷，實例之間資料不互通，請確認應用支援這種部署方式。',
  'pages.appStore.form.addVolumeTitle': '新增儲存卷',
  'pages.appStore.form.volumeSize': '容量',
  'pages.appStore.form.volumeSizeRange': '容量範圍：1–500 Gi',
  'pages.appStore.form.confirm': '確認',
  'pages.appStore.form.fixErrors': '請先修正表單中標紅的內容',
  'pages.appStore.form.updateSuccess': '部署「{name}」變更已提交',
  'pages.appStore.form.loadFailed':
    '讀取部署設定失敗，部署可能已被刪除或叢集暫時無法使用',
  'pages.appStore.form.backToList': '返回部署列表',
  'pages.appStore.detail.eventsTab': '事件',
  'pages.appStore.detail.noPodsPaused': '部署已暫停，可在列表的「更多」中啟動',
  'pages.appStore.detail.restartPodTitle': '重啟 Pod「{name}」？',
  'pages.appStore.detail.restartPodDescription':
    'Pod 會被刪除並由叢集自動重建。',
  'pages.appStore.detail.restartPodDone': 'Pod「{name}」正在重啟',
  'pages.appStore.events.type': '類型',
  'pages.appStore.events.Warning': '警告',
  'pages.appStore.events.Normal': '正常',
  'pages.appStore.events.reason': '原因',
  'pages.appStore.events.object': '物件',
  'pages.appStore.events.message': '訊息',
  'pages.appStore.events.count': '次數',
  'pages.appStore.events.lastSeen': '最近發生',
  'pages.appStore.events.warningsOnly': '只看警告',
  'pages.appStore.events.empty': '暫無事件',
  'pages.appStore.events.retentionHint': '叢集預設只保留最近 1 小時的事件。',
  'pages.appStore.logs.modeLive': '即時',
  'pages.appStore.logs.modeSnapshot': '快照',
  'pages.appStore.logs.stream.connecting': '連線中',
  'pages.appStore.logs.stream.live': '即時推送中',
  'pages.appStore.logs.stream.ended': '已結束',
  'pages.appStore.logs.stream.error': '連線中斷',
  'pages.appStore.logs.searchPlaceholder': '搜尋關鍵字',
  'pages.appStore.logs.matchCount': '{count} 行符合',
  'pages.appStore.logs.onlyMatches': '只顯示符合行',
  'pages.appStore.logs.timestamps': '顯示時間',
  'pages.appStore.logs.wrap': '自動換行',
  'pages.appStore.logs.download': '下載完整日誌',
  'pages.appStore.logs.downloadFailed': '下載日誌失敗',
  'pages.appStore.logs.fullscreen': '全螢幕',
  'pages.appStore.logs.exitFullscreen': '離開全螢幕（Esc）',
  'pages.appStore.logs.loading': '正在載入日誌…',
  'pages.appStore.logs.jumpToLatest': '跳到最新',
  'pages.appStore.deployments.detail': '詳情',
  'pages.appStore.deployments.scale': '伸縮',
  'pages.appStore.deployments.replicas': '{replicas} 副本',
  'pages.appStore.scale.title': '調整「{name}」副本數',
  'pages.appStore.scale.submit': '確定',
  'pages.appStore.scale.replicas': '目標副本數',
  'pages.appStore.scale.current': '目前副本數：{replicas}',
  'pages.appStore.scale.storageLimit':
    '此部署建立於舊版本，所有實例共用同一個儲存卷，只能執行 1 個實例。',
  'pages.appStore.scale.success': '已將「{name}」調整為 {replicas} 個副本',
  'pages.appStore.detail.title': '部署詳情 · {name}',
  'pages.appStore.detail.podsTab': 'Pod 與監控',
  'pages.appStore.detail.logsTab': '日誌',
  'pages.appStore.detail.refresh': '重新整理',
  'pages.appStore.detail.podName': 'Pod 名稱',
  'pages.appStore.detail.podStatus': '狀態',
  'pages.appStore.detail.restarts': '重啟次數',
  'pages.appStore.detail.cpu': 'CPU 使用率',
  'pages.appStore.detail.memory': '記憶體使用率',
  'pages.appStore.detail.cpuUsage': '{used} 核 / 上限 {limit} 核',
  'pages.appStore.detail.memoryUsage': '{used} MiB / 上限 {limit} MiB',
  'pages.appStore.detail.node': '節點 / IP',
  'pages.appStore.detail.startTime': '啟動時間',
  'pages.appStore.detail.viewLogs': '日誌',
  'pages.appStore.detail.previousLogs': '上次執行日誌',
  'pages.appStore.detail.phase.Running': '執行中',
  'pages.appStore.detail.phase.Pending': '啟動中',
  'pages.appStore.detail.phase.Failed': '異常',
  'pages.appStore.detail.metricsUnavailable':
    '叢集未安裝 metrics-server，暫無法顯示 CPU 與記憶體用量。',
  'pages.appStore.detail.noPods': '目前沒有執行中的 Pod',
  'pages.appStore.detail.autoRefreshHint': '每 {seconds} 秒自動重新整理',
  'pages.appStore.detail.tailLines': '最後 {lines} 行',
  'pages.appStore.detail.emptyLogs': '暫無日誌輸出',
  'pages.appStore.custom.image': '容器映像檔',
  'pages.appStore.custom.imagePlaceholder':
    '如 nginx:1.27 或 harbor.3as.cn/app:v1',
  'pages.appStore.custom.imageRequired': '請輸入容器映像檔位址',
  'pages.appStore.custom.imageInvalid': '映像檔位址不能包含空格',
  'pages.appStore.custom.memory': '記憶體',
  'pages.appStore.custom.replicasRequired': '請輸入副本數',
  'pages.appStore.custom.addPort': '新增連接埠',
  'pages.appStore.custom.protocol': '協定',
  'pages.appStore.custom.publicAccess': '公網存取',
  'pages.appStore.custom.publicHttpOnly': '僅 HTTP 協定支援公網存取',
  'pages.appStore.custom.portRequired': '請輸入連接埠號',
  'pages.appStore.custom.portDuplicate': '連接埠號不能重複',
  'pages.appStore.custom.envGroup': '環境變數',
  'pages.appStore.custom.envKey': '變數名稱',
  'pages.appStore.custom.envValue': '變數值',
  'pages.appStore.custom.envKeyInvalid': '以字母或底線開頭，僅包含英數字底線',
  'pages.appStore.custom.envKeyDuplicate': '環境變數名稱不能重複',
  'pages.appStore.custom.mountPath': '掛載路徑（絕對路徑）',
  'pages.appStore.custom.mountPathInvalid': '必須為以 / 開頭的絕對路徑',
  'pages.appStore.custom.mountPathDuplicate': '掛載路徑不能重複',
  'pages.appStore.custom.command': '啟動命令',
  'pages.appStore.custom.args': '啟動參數',
  'pages.appStore.custom.argsHelp': '容器啟動參數，多個參數以空格或逗號分隔',
  'pages.appStore.custom.submit': '確認部署',
  'pages.appStore.custom.success': '自訂部署「{name}」已提交',
  'pages.appStore.custom.envKeyRequired': '請輸入變數名稱',
  'pages.appStore.custom.mountPathRequired': '請輸入掛載路徑',
  'pages.appStore.deployments.emptyDescription':
    '從部署範本一鍵安裝，或填寫映像參數自訂部署。',
  'pages.appStore.images.title': '映像倉庫',
  'pages.appStore.images.description':
    '瀏覽平台共用映像倉庫中的容器映像，可直接選擇標籤部署到企業叢集。',
  'pages.appStore.images.name': '映像名稱',
  'pages.appStore.images.searchPlaceholder': '依映像名稱搜尋',
  'pages.appStore.images.address': '倉庫位址',
  'pages.appStore.images.tagCount': '標籤數',
  'pages.appStore.images.lastPushedAt': '最近推送',
  'pages.appStore.images.actions': '操作',
  'pages.appStore.images.viewTags': '查看標籤',
  'pages.appStore.images.empty': '映像倉庫中還沒有映像',
  'pages.appStore.images.refresh': '重新整理',
  'pages.appStore.images.readOnlyHint':
    '映像倉庫由平台統一管理，你可以瀏覽並使用這些映像部署應用。',
  'pages.appStore.images.tag': '標籤',
  'pages.appStore.images.digest': '摘要',
  'pages.appStore.images.size': '大小',
  'pages.appStore.images.pushedAt': '推送時間',
  'pages.appStore.images.lastPulledAt': '最近拉取',
  'pages.appStore.images.inUse': '使用中',
  'pages.appStore.images.inUseCount': '{count} 個部署',
  'pages.appStore.images.deploy': '部署',
  'pages.appStore.images.delete': '刪除',
  'pages.appStore.images.cancel': '取消',
  'pages.appStore.images.deleteTitle': '刪除映像標籤「{name}」？',
  'pages.appStore.images.deleteDescription':
    '刪除後無法再拉取該標籤，已拉取到節點上的副本不受影響。',
  'pages.appStore.images.deleteBlocked':
    '仍有部署在使用該標籤，請先刪除相關部署',
  'pages.appStore.images.deleted': '已刪除 {name}',
};
